import {Injectable} from '@angular/core';
import {Router} from '@angular/router';

@Injectable()
export class RedirectUserService {

    public url: string = "";
    public listOfUsers: string = "";

    constructor(private router: Router) {
    }


}
